import { CollideEvent, CollideId } from '../../defs/collide';
import { SodaBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { CollideHandler, ICollision } from './ICollision';
import { SodaLaunchEffect } from '../effects/SodaLaunchEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { waitFor } from '../../../lib/util/waitFor';
import { SodaBlockView } from '../../views/blocks/SodaBlockView';

/*
  Soda block collision resolver
*/
export class SodaCollision implements ICollision {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _entity: SodaBlockEntity;
  // map
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this._resolveTap,
    goal: this._resolveGoal,
  };

  constructor(scene: GameScene, entity: SodaBlockEntity) {
    this._scene = scene;
    this._entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  // private: resolvers
  //-------------------------------------------------------------------------
  private async _resolveTap() {
    await new InvalidEffect(this._entity).execute();
    return false;
  }

  private async _resolveGoal() {
    const { c } = this._entity;
    const component = c.blockSoda;
    const view = component.view;

    // Already broken.
    if (component.counter <= 0) {
      return false;
    }

    this._scene?.events.publish({ id: 'poke' });

    // Decrement counter.
    component.counter--;
    view.updateFill(component.counter);

    // If counter is 0.
    if (component.counter <= 0) {
      await waitFor(SodaBlockView.FILL_ANIMATION_DURATION * 1000);
      await new SodaLaunchEffect(this._scene, {
        entity: this._entity,
      }).execute();
    }

    return true;
  }
}
